module.exports = __webpack_public_path__ + "static/chameleon_banner-46bcf96c1cd233dfb5f14c90bb1e1d18.png";